import React, { useEffect, useState } from 'react';
import axios, { AxiosResponse } from "axios";
import { instance } from '../networking/axios';
import { IOptionsContainer, ISession } from '../networking/Options';
import ReferralCabinetScreen from './ReferralCabinetScreen';
import { IB2CInfo } from '../mainscreen/model/B2CInfo';
import getMobileOperatingSystem from '../helpers/getMobileOperationSystem';
import { openPassport } from '../mainscreen/header/Avatar';
import { IReferralInfo, IReferralSettingsInfo } from './ReferralInfo';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    useRouteMatch,
} from "react-router-dom";
import ReferralMobileChat from './ReferralMobileChat';
export interface IReferralAppInfo {
    session?: ISession
    b2cInfo: IB2CInfo
    isMobile: boolean
    referral?: IReferralInfo
    referralSettings: IReferralSettingsInfo
    promocodeTemplate?: string,
    isLoggedIn: boolean
}

export const ReferralAppContext = React.createContext<IReferralAppInfo | undefined>(undefined);

function ReferalApp() {
    const [info, setInfo] = useState<IReferralAppInfo>();
    let { url } = useRouteMatch();

    useEffect(() => {
        const getInfo = async () => {
            let isLoggedIn = true;
            // to create user
            const referralInfoResponse = await instance.get(
                '/user_app/promo/referral',
                { headers: { 'IC_AppBuild': '104335' } }
            ).catch((error) => {
                isLoggedIn = false;
                return null;
            });
            const referral = (referralInfoResponse as AxiosResponse<IReferralInfo>)?.data;

            const sessionParams = new URLSearchParams();
            sessionParams.append('multi_sessions', "1");

            const externalSessionRequest = instance.get('/b2c/sessions/current', { params: sessionParams }).catch((error) => {
                return null;
            });

            const settingsRequest = instance.get('/api/fake/settings/list');

            axios.all([externalSessionRequest, settingsRequest]).then((responses: (AxiosResponse | null)[]) => {
                const session = (responses[0] as AxiosResponse<ISession>)?.data;
                const settings = (responses[1] as AxiosResponse<any>).data;

                let mobileOperationSystem = getMobileOperatingSystem()
                setInfo({
                    session: session,
                    referral: referral,
                    b2cInfo: settings["options"]["b2c_web_info"],
                    referralSettings: settings["options"]["referral_info"],
                    promocodeTemplate: settings["options"]["promocode_template"],
                    isMobile: mobileOperationSystem !== "unknown",
                    isLoggedIn: isLoggedIn,
                });
            });
        }
        getInfo();
    }, []);

    if (info != null) {
        const hasPlus = info.session?.user.plus?.is_activated ?? false;
        const chatId = hasPlus ? "referral_plus" : "referral";
        return <div className="App">
            <ReferralAppContext.Provider value={info}>
                <Router>
                    <Switch>
                        <Route path={`${url}/chat`}>
                            <ReferralMobileChat chatId={chatId} />
                        </Route>
                        <Route>
                            <ReferralCabinetScreen />
                        </Route>
                    </Switch>
                </Router>
            </ReferralAppContext.Provider>
        </div>
    } else {
        return <div />
    }
}

export default ReferalApp;